module.exports = __webpack_public_path__ + "media/Loping.5079073d.mp3";